function evaluateCellScrollWidth(e: HTMLElement, offset = 0) {
  return e.scrollWidth - offset > e.clientWidth
}

export default evaluateCellScrollWidth
